import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "../src/styles/custom.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));

window.global = {
  server_url: "http://192.168.1.24:8000",
};

root.render(
  // <React.StrictMode>
  <BrowserRouter basename="/home">
    <App />
  </BrowserRouter>
  // </React.StrictMode>
);
